"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverifyEmailResultReducer = void 0;
var ReverifyEmailResultState_init_1 = require("@/pages/reverifyEmail/states/ReverifyEmailResultState.init");
exports.reverifyEmailResultReducer = function (state, action) {
    if (state === void 0) { state = ReverifyEmailResultState_init_1.defaultReverifyEmailResultState; }
    return state;
};
